import {Requirement, Simulation} from 'types';
import {PAGE_PATHS} from 'pages';
import {useTranslation} from 'react-i18next';
import {createNamespaceForSimulationsFeature} from 'features/Simulations/simulations.utils';
import {GetSimulationComparisonQuery} from './hooks/simulationComparison.generated';

export const NAMESPACE_OF_SIMULATION_COMPARISON: string =
	createNamespaceForSimulationsFeature('simulationComparison');

export const useTranslationForSimulationComparison = () => {
	return useTranslation(NAMESPACE_OF_SIMULATION_COMPARISON);
};

export interface FieldsToCreatePathOfSimulationComparisonPage {
	simulationId: Simulation['id'];
	idOfSimulationToCompareTo: Simulation['id'];
}

export const createPathOfSimulationComparisonPage = ({
	simulationId,
	idOfSimulationToCompareTo,
}: FieldsToCreatePathOfSimulationComparisonPage): string => {
	return `${PAGE_PATHS.simulations}/${simulationId}/compare/${idOfSimulationToCompareTo}`;
};

export type ComparedSimulationRequirement = NonNullable<
	GetSimulationComparisonQuery['simulationComparison']
>['requirements'][number];

export type ComparedSimulationRequirementRow = Requirement & {
	comparisonResult: ComparedSimulationRequirement['comparisonResult'];
};

/**
 * The server already returns the rows sorted and de-duplicated, so this only flattens
 * them into the shape the column renderers expect.
 */
export const mapComparedRequirements = (
	data: GetSimulationComparisonQuery | undefined,
): ComparedSimulationRequirementRow[] => {
	return (data?.simulationComparison?.requirements ?? []).map(
		({comparisonResult, requirement}) =>
			({
				...requirement,
				comparisonResult,
			} as ComparedSimulationRequirementRow),
	);
};
